export default "__VITE_ASSET__DhjNQMfK__"